module.exports = __webpack_public_path__ + "media/customizations/meridiana/logo-9d617edb216dc5b018249331eb9168e9.png";